<template>
  <v-container>
    <ResourceDialog
      @save="save"
      ref="termsAgreementDialog"
      :cancellable="false"
      :max-width="800"
      :processing="processing"
      :save-button-text="termsAgreement.accept_label"
      :title="termsAgreement.title"
      center-title
    >
      <template #form>
        <SafeHtml
          :html="termsAgreement.content"
          class="pa-4"
        />
      </template>
    </ResourceDialog>
  </v-container>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Api from '@/manager/services/bright_finder';
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';
import SafeHtml from '@/shared/components/SafeHtml.vue';
import useEventBus from '@/shared/composables/useEventBus';

const eventBus = useEventBus();
const router = useRouter();
const store = useStore();

const processing = ref(false);
const termsAgreement = ref(store.state.config.terms_agreement);
const termsAgreementDialog = ref(null);

function load() {
  termsAgreementDialog.value.open({});
}

async function save() {
  processing.value = true;

  const response = await Api.manager.profile.updateSelf({
    body: {
      terms_agreement_id: termsAgreement.value.id,
    },
  });

  if (response.status !== 200) {
    processing.value = false;
    return;
  }

  const profile = {
    ...store.state.profile,
    terms_agreement_id: response.data.terms_agreement_id,
  };
  store.commit('setProfile', profile);
  eventBus.chime('Profile saved');

  processing.value = false;

  await router.replace({ name: 'Welcome' });
}

onMounted(load);
</script>
